import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HomeMyRecommendationGeneralHealthActions = createActionGroup({
  source: 'Home My Recommendation General Health',
  events: {
    Fetch: emptyProps(),
    Reset: emptyProps(),
    'Set Data': props<{ data: Array<any> }>()
  }
});
